export class SaveTopicDialogLocalizationsModel {
    heading: string;
    nameLabel: string;
    nameHint: string;
    workflowSettingsHeading: string;
    checkboxLabel: string;
    tooltip: string;
    limitReachedMessage: string;

    constructor(
        heading: string,
        nameLabel: string,
        nameHint: string,
        workflowSettingsHeading: string
    ) {
        this.heading = heading;
        this.nameLabel = nameLabel;
        this.nameHint = nameHint;
        this.workflowSettingsHeading = workflowSettingsHeading;
    }
}
